import styled from "styled-components";

export const Container = styled.div``;

export const AreaStatus = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;
